import { Input } from '@chakra-ui/react';
import { FieldError } from 'react-hook-form';
import { CustomFormControl } from './CustomFormControl';

export interface ICustomInput {
  label?: string;
  error?: FieldError | undefined;
  value?: any;
  isRequired?: boolean;
}

export const CustomInput = (props: ICustomInput) => {
  const { label, ...restProps } = props;

  return (
    <CustomFormControl label={label} error={restProps?.error} value={restProps?.value} isRequired={restProps?.isRequired}>
      <Input {...restProps} />
    </CustomFormControl>
  );
};
